import { toast } from 'sonner';

export type MsgItem =
  | string
  | {
      content: string;
      type: 'error' | 'warning' | 'info' | 'success' | 'message' | 'loading';
    };

const msgs: MsgItem[] = [];

const syncToLocalStorage = (clear?: boolean) => {
  localStorage.setItem('msgOnReload', JSON.stringify(clear ? [] : msgs));
};

/**
 * 添加在页面刷新之后要显示的消息
 * @param msg 需要显示的消息
 */
export const addMsgOnReloaded = (msg: MsgItem) => {
  msgs.push(msg);
  syncToLocalStorage();
};

/**
 * 页面加载后弹出之前通过addMsgOnReloaded添加的消息
 */
export const sendMsgOnReloaded = () => {
  const msgStr = localStorage.getItem('msgOnReload');
  if (msgStr) {
    const list = JSON.parse(msgStr) as MsgItem[];
    list.forEach((item) => {
      const content = typeof item === 'string' ? item : item.content;
      const type = typeof item === 'string' ? 'info' : item.type;
      toast[type](content);
    });
    syncToLocalStorage(true);
  }
};
